import React, { useState } from "react";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { useQuery } from "@apollo/client";
import {
  GET_OWNER_LISTING_RESERVED_DAYS,
  GET_UPCOMING_DAILY_PRICES,
} from "@/graphql/queries/daily";
import { DatePicker } from "@aqar-app/react-ui";
import dayjs from "dayjs";
import css from "./.module.scss";
import { financialFormat } from "@/lib/helpers";
import Skeleton from "@/components/skeleton";

export function OwnerCalendarSkeleton() {
  return (
    <Skeleton className={css.ownerCalendar + " " + css.skeleton}>
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
      <Skeleton.Item />
    </Skeleton>
  );
}
export function OwnerCalendar({ id, price }) {
  const [disabledDates, setDisabledDates] = useState({
    owner: [],
    system: [],
  });
  const { token } = useAuthState();
  const [pricesMap, setPricesMap] = useState({});
  useQuery(GET_OWNER_LISTING_RESERVED_DAYS, {
    context: { token },
    variables: { id },
    onCompleted: (res) => {
      setDisabledDates({
        owner: (
          res?.DailyRenting?.getReservedDatesOfListingForOwner
            ?.filter((item) => item.is_reserved_by_owner)
            .map((item) => item.reserved_date) || []
        ).reduce(
          (acc, item) => ({ ...acc, [dayjs(item).format("DD-MM-YYYY")]: item }),
          {},
        ),
        system: (
          res?.DailyRenting?.getReservedDatesOfListingForOwner
            ?.filter((item) => !item.is_reserved_by_owner)
            .map((item) => item.reserved_date) || []
        ).reduce(
          (acc, item) => ({ ...acc, [dayjs(item).format("DD-MM-YYYY")]: item }),
          {},
        ),
      });
    },
    ssr: false,
    fetchPolicy: "no-cache",
    skip: !id,
  });
  useQuery(GET_UPCOMING_DAILY_PRICES, {
    context: { token },
    fetchPolicy: "no-cache",
    variables: { id },
    onCompleted: (res) => {
      setPricesMap(
        res?.DailyRenting?.getUpcomingListingDailyPrices.reduce(
          (acc, item) => ({
            ...acc,
            [dayjs(item.day_date).format("DD-MM-YYYY")]: item,
          }),
          {},
        ),
      );
    },
  });
  return (
    <div className={css.ownerCalendar}>
      <DatePicker
        readonly
        maxDate={dayjs().add(182, "days").valueOf()}
        minDate={dayjs(Date.now()).startOf("day").valueOf()}
        hideYearControls
        key={disabledDates.toString()}
        locale="ar"
        decoratedButton={(data) => {
          if (disabledDates.owner[data.dateString]) {
            return React.cloneElement(data.btnUI, {
              className: css.ownerReserved + " " + css.btn,
              children: (
                <>
                  {data.btnUI.props.children}
                  <span className={css.p}>
                    {financialFormat(
                      pricesMap[data.dateString]?.price || price,
                    )}
                  </span>
                </>
              ),
            });
          }
          if (disabledDates.system[data.dateString]) {
            return React.cloneElement(data.btnUI, {
              className: css.systemReserved + " " + css.btn,
              children: (
                <>
                  {data.btnUI.props.children}

                  <span className={css.p}>
                    {financialFormat(
                      pricesMap[data.dateString]?.price || price,
                    )}
                  </span>
                </>
              ),
            });
          }

          return React.cloneElement(data.btnUI, {
            className: css.btn,
            disabled:
              data.btnUI.props.disabled || !pricesMap[data.dateString]?.price,
            children: (
              <>
                {data.btnUI.props.children}
                <span className={css.p}>
                  {financialFormat(pricesMap[data.dateString]?.price || "")}
                </span>
              </>
            ),
          });
        }}
      />
      <div className={css.legends}>
        <p className={css.available}>ايام متاحة</p>
        <p className={css.selected}>مقفل من المضيف</p>
        <p className={css.disabled}>ايام محجوزة</p>
      </div>
    </div>
  );
}
